<template>
  <layout-main-inner
    v-loading="loading"
    class="order-detail"
    title="订单详情">
    <el-form
      ref="ruleForm"
      class="order-create-wrap"
      :model="info"
      label-position="top">
      <div>
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="订单"
            name="1"></el-tab-pane>
          <el-tab-pane
            label="售后"
            name="4"></el-tab-pane>
        </el-tabs>
      </div>
      <template v-if="activeName === '1'">
        <layout-card-wrap
          v-loading="loading"
          hasHeaderSlot>
          <template slot="title">基本信息</template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="订单号:"
                prop="code">{{ info.orderNumber }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="支付时间:"
                prop="tradeTime">{{ info.payTime | dateformat() }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="订单状态:"
                prop="tradeTime">{{ info.orderStatusName }}</el-form-item>
            </el-col>
            <el-col
              v-if="info.expressId"
              :span="8">
              <el-form-item
                label="物流信息:"
                prop="tradeTime">{{ info.expressName }}（{{ info.courierNumber }}）</el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item
                label="备注:"
                prop="remark">{{ info.remarks || '-' }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="收件人信息:">
                {{ info.deliveryName }}-{{ info.deliveryPhone }}-{{ info.provinceName }}{{ info.cityName }}{{ info.areaName }}{{ info.detailedAddress }}
              </el-form-item>
            </el-col>
          </el-row>
        </layout-card-wrap>
        <layout-card-wrap
          hasHeaderSlot
          style="margin-top:15px">
          <template slot="title">订单明细</template>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                label="优惠信息:">
                <div
                  v-if="info.couponDiscount > 0"
                  style="color: red">优惠券抵扣：-¥{{ info.couponDiscount }}</div>
                <div
                  v-if="info.cashPoints > 0"
                  style="color: red">积分抵扣：-¥{{ info.cashPoints }}</div>
                <div
                  v-if="info.memberDiscount > 0"
                  style="color: red">会员抵扣：-¥{{ info.memberDiscount }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table
            border
            style="margin-top: 10px"
            show-summary
            :summary-method="getSummaries"
            :data="info.orderItems">
            <el-table-column
              label="商品名称"
              prop="productName">
            </el-table-column>
            <el-table-column
              label="商品描述"
              prop="productDesc">
            </el-table-column>
            <el-table-column
              :label="'下单数量'"
              prop="buyCount"></el-table-column>
            <el-table-column
              label="零售价"
              prop="price">
              <template slot-scope="{row}">
                ¥{{ row.price }}
              </template>
            </el-table-column>
            <el-table-column
              label="成交价"
              prop="totalPrice">
              <template slot-scope="{row}">
                ¥{{ row.totalPrice }}
              </template>
            </el-table-column>
          </el-table>
        </layout-card-wrap>
        <layout-card-wrap
          hasHeaderSlot
          style="margin-top:15px">
          <template slot="title">物流信息</template>
          <el-steps
            v-if="traces.length> 0"
            direction="vertical"
            :active="traces.length - 1">
            <el-step
              v-for="(item, index) in traces"
              :key="index"
              :title="item.AcceptTime"
              :description="item.AcceptStation"></el-step>
          </el-steps>
          <empty
            v-else
            content="暂无物流信息" />
        </layout-card-wrap>
      </template>

      <template v-if="activeName === '4'">
        <template v-if="saleList.length > 0">
          <layout-card-wrap
            v-loading="loading"
            hasHeaderSlot>
            <template slot="title">售后明细</template>
            <el-timeline>
              <el-timeline-item
                v-for="item in saleList"
                :key="item.refundNumber"
                :timestamp="item.createdTime | dateformat()"
                placement="top">
                <el-card>
                  <el-form
                    label-width="70px"
                    label-position="left">
                    <el-form-item label="售后单号：">
                      {{ item.refundNumber }}
                    </el-form-item>
                    <el-form-item label="客户备注：">
                      {{ item.details }}
                    </el-form-item>
                    <el-form-item label="售后类型：">
                      {{ item.type | typeFormat() }}
                      <!-- <span v-if=" item.type === 2">退货</span>
                      <span v-if=" item.type === 3">换货</span> -->
                    </el-form-item>
                    <el-form-item label="状态：">
                      {{ item.statusName }}
                    </el-form-item>
                    <el-form-item
                      v-if="item.resultDesc"
                      label="商家备注：">
                      {{ item.resultDesc }}
                    </el-form-item>
                    <el-form-item label="图片信息：">
                      <image-list
                        v-if="item.images.length > 0"
                        :list="item.images" />
                    </el-form-item>
                    <el-form-item
                      v-if="item.orderReturnDetails && item.orderReturnDetails.length > 0"
                      label="订单明细:"
                      prop="orderReturnDetails">
                      <el-table
                        v-loading="loading"
                        max-height="400px"
                        :data="item.orderReturnDetails"
                        border>
                        <el-table-column
                          :resizable="false"
                          label="商品名称"
                          prop="productName"></el-table-column>
                        <el-table-column
                          :resizable="false"
                          label="商品描述"
                          width="280"
                          prop="productDesc"></el-table-column>
                        <el-table-column
                          label="下单数量"
                          width="70"
                          :resizable="false"
                          prop="goodsCount">
                        </el-table-column>
                        <el-table-column
                          label="退货数量"
                          :resizable="false"
                          prop="returnedGoodsCount">
                        </el-table-column>
                      </el-table>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </layout-card-wrap>
        </template>
        <empty v-else />

      </template>
    </el-form>

  </layout-main-inner>
</template>
<script>
import ImageList from '../../components/image-list.vue'
import NP from 'number-precision'
export default {
  name: 'DetailsOrder',
  components: { ImageList },
  filters: {
    typeFormat(val) {
      const type = {
        1: '退款',
        2: '退货',
        3: '换货'
      }
      return type[val]
    }
  },
  data() {
    return {
      activeName: '1',
      loading: false,
      info: {
        orderNumber: '', // 订单编号
        orderType: '', // 订购状态
        createdTime: null, // 下单时间
        payTime: null, // 支付时间
        deliveryTime: null, // 送件时间
        checkinTime: null, // 签收时间
        completeTime: null, // 完成时间
        orderStatusName: '', // 订单状态
        deliveryName: '', // 收件人
        deliveryPhone: '', // 手机号
        provinceName: '', // 省份
        cityName: '', // 市区
        areaName: '', // 地区
        detailedAddress: '', // 详细地址
        orderItems: [] // 兑换物品
      },
      traces: [],
      saleList: [],
      orderType: {
        1: '现金',
        2: '积分',
        3: '奖品'
      }
    }
  },
  computed: {
  },
  mounted() {
    this.activeName = this.$route.query.activeName || '1'
    if (this.$route.query.orderId) {
      this.getorder()
      this.getorderdeliverytrace()
      this.fetchList()
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1)
    },
    getorder() {
      this.loading = true
      this.$store.dispatch('order/getorder', {
        payload: {
          'vendorId': this.$route.query.vendorId,
          'orderId': this.$route.query.orderId
        },
        success: res => {
          this.loading = false
          this.info = {
            ...this.info,
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计：¥' + this.info.payAmount
          return
        }
        if (index === 1) {
          return
        }
        const values = data.map(item => {
          if (index === 3) {
            return NP.times(Number(item[column.property]), Number(item.buyCount))
          } else {
            return Number(item[column.property])
          }
        })
        // console.log(values)
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return NP.plus(prev, curr)
            } else {
              return prev
            }
          }, 0)
          if (index === 2) {
            sums[index] += '件'
          } else {
            sums[index] = '¥' + sums[index]
          }
        } else {
          sums[index] = 'N/A'
        }
      })
      return sums
    },
    getorderdeliverytrace() {
      this.loading = true
      this.$store.dispatch('order/getorderdeliverytrace', {
        payload: {
          'vendorId': this.$route.query.vendorId,
          'orderId': this.$route.query.orderId
        },
        success: res => {
          this.loading = false
          this.traces = res.data.traces || []
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('order/getorderreturns', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          'vendorId': this.$route.query.vendorId,
          'orderNumber': this.$route.query.orderNumber
        },
        success: res => {
          this.loading = false
          this.saleList = res.data.records.map(i => {
            i.images = i.images ? i.images.split(',') : []
            return i
          })
          this.totalNum = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.order-detail {
  // .zz-main-inner-header{
  //   margin-bottom: 0;
  // }
  .el-form--label-top .el-form-item__label {
    padding-bottom 0;
  }
  .el-tabs__header {
    margin-bottom: 8px

    .el-tabs__nav-wrap{
      background: #fff;
      padding 0 20px
    }
  }
.order-create-wrap {
  .el-table__footer-wrapper tbody {
    td:nth-child(1) {
      font-size: 14px !important;
      color: red !important;
    }
  }

  .el-form-item {
    margin-bottom: 0 !important;
  }
}
}
</style>
